import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import cx from 'classnames';

const propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  to: PropTypes.string,
  url: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  titleKey: PropTypes.string, // if titleKey is defined, it will use Translate component
  subtitleKey: PropTypes.string, // if subtitleKey is defined, it will use Translate component
  illustration: PropTypes.string.isRequired,
  style: PropTypes.object,
  children: PropTypes.element,
  clickHandler: PropTypes.func,
};

const defaultProps = {
  to: null,
  url: null,
  target: null,
  rel: null,
  title: null,
  subtitle: null,
  titleKey: null,
  subtitleKey: null,
  illustration: null,
  clickHandler: () => {},
  style: null,
  children: null,
};

const PanelBar = ({ clickHandler, illustration, title, subtitle }) => (
  <div
    className="bar flex-row"
    onClick={event => clickHandler(event)}>
    { illustration && <div className="img-holder"><img src={illustration} alt={title} /></div>}
    <div>
      <div className="title">{ title }</div>
      {subtitle && <div className="subtitle">{ subtitle }</div>}
    </div>
  </div>
);
PanelBar.propTypes = propTypes;
PanelBar.defaultProps = defaultProps;

const PanelBarWrapper = ({ url, to, target, rel, ...props }) => {
  const bar = <PanelBar {...props} />;
  if (url) {
    return (
      <a
        href={url}
        target={target}
        rel={target === '_blank' ? 'noreferrer noopener' : rel}>
        {bar}
      </a>
    );
  }

  if (to) {
    return <Link to={to}>{bar}</Link>;
  }

  return bar;
};
PanelBarWrapper.propTypes = propTypes;
PanelBarWrapper.defaultProps = defaultProps;

class PanelListItem extends React.PureComponent {
  render() {
    const {
      children,
      style,
      illustration,
    } = this.props;
    return (
      <li
        className={cx('panel', { 'has-image': !!illustration })}
        style={style}>
        <PanelBarWrapper {...this.props} />
        { children }
      </li>
    );
  }
}

PanelListItem.propTypes = propTypes;
PanelListItem.defaultProps = defaultProps;
export default PanelListItem;
